<template>
  <DxDataGrid ref="dataGridRef" :allowColumnReordering="true" :data-source="dsRoluri" :allowColumnResizing="true"
    key-expr="ID" :columnAutoWidth="false" :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
    :syncLookupFilterValues="false" :filter-sync-enabled="true" show-row-lines="true" show-column-lines="false"
    @selection-changed="onSelectionChanged" @row-inserting="onRowInserting" @row-removing="onRowRemoving"
    @rowUpdating="onRowUpdating" class="border">
    <DxSelection mode="single" />
    <DxFilterRow :visible="true" />
    <DxPaging :page-size="5" :page-index="1" />
    <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
    <DxSorting mode="multiple" />
    <DxStateStoring :enabled="true" :filterValue="false" storage-key="Roluri" />
    <DxToolbar>
      <DxItem>
        <template #default>
          <DxButton icon="add" type="success" @click="onAddClick" />
        </template>
      </DxItem>
      <DxItem>
        <template #default>
          <DxButton icon="refresh" @click="onRefreshClick" />
        </template>
      </DxItem>
    </DxToolbar>
    <DxEditing :allowUpdating="true" :allowDeleting="true" :allowAdding="true" :showCloseButton="false" mode="form">
      <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="550" :height="430">
        <DxToolbarItem :template="customTitleTemplate" />
        <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="successButtonOptions" />
        <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
      </DxPopup>
      <DxFormGrid>
        <DxItem :col-span="1" :col-count="1" item-type="group">
          <DxItem data-field="Cod" :editor-options="{ width: 510 }">
            <DxValidationRule>
              <DxRequiredRule />
            </DxValidationRule>
          </DxItem>
          <DxItem data-field="Nume" :editor-options="{ width: 510 }">
            <DxValidationRule>
              <DxRequiredRule />
            </DxValidationRule>
          </DxItem>
          <DxItem data-field="Explicatie" :editor-options="{ width: 510, height: 120 }">
            <DxValidationRule>
              <DxRequiredRule />
            </DxValidationRule>
          </DxItem>
        </DxItem>
      </DxFormGrid>
    </DxEditing>
    <DxColumn data-field="Cod" :visible="false" />
    <DxColumn data-field="Nume" />
    <DxColumn data-field="Explicatie" />
  </DxDataGrid>
  <DxPopupAdd v-model:visible="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false" :showTitle="true"
    :width="550" :height="450">
    <template #title>
      <div
        style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold; padding: 10px; padding-left: 20px;">
        Adăugare
      </div>
    </template>

    <div>
      <DxForm :formData="formData">
        <DxItem :col-span="2" :col-count="2" item-type="group">
          <DxItem dataField="Nume" isRequired="true" :editor-options="{ width: 260 }">
            <DxValidationRule>
              <DxRequiredRule />
            </DxValidationRule>
          </DxItem>

          <DxItem dataField="Cod" :editor-options="{ width: 235 }">
            <DxValidationRule>
              <DxRequiredRule />
            </DxValidationRule>
          </DxItem>
        </DxItem>

        <DxItem dataField="Explicatie" :editor-options="{ height: 80, width: 510 }" :label="{ text: 'Explicație' }">
          <DxValidationRule>
            <DxRequiredRule />
          </DxValidationRule>
        </DxItem>
      </DxForm>

      <div style="margin: 50px 0; text-align: left;">
        <DxButton text="Copiază drepturile unui rol existent" type="default" width="3200" @click="onCopyRights" />
      </div>

       <div style="display: flex; justify-content: flex-end; gap: 8px;">
                    <DxButton text="Salvează" type="success" width="100" @click="onSaveAdd" />
                    <DxButton text="Închide" type="danger" width="100" @click="onCancel" />
                </div>
    </div>
  </DxPopupAdd>

  <DxPopupSelect v-model:visible="isCopyPopupVisible" :closeOnOutsideClick="false" :showCloseButton="true"
    :drag-enabled="true" :resize-enabled="true" :show-title="true" :width="550" :height="450">
    <template #title>
      <div
        style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold; padding: 10px; padding-left: 20px;">
        Alege rolul sursă
      </div>
    </template>

    <DxDataGrid :data-source="rolesDataSource" key-expr="ID" :show-borders="true" :hoverStateEnabled="true"
      :focusedRowEnabled="true" :columnAutoWidth="true" @selection-changed="onRoleGridSelectionChanged"
      @row-dbl-click="onConfirmCopy">
      <DxSelection mode="single" />
      <DxFilterRow :visible="true" />
      <DxPaging :page-size="10" />
      <DxSorting mode="multiple" />
      <DxLoadPanel :enabled="true" />
      <DxColumn data-field="Cod" :visible="false" />
      <DxColumn data-field="Nume" />
      <DxColumn data-field="Explicatie" caption="Explicație" />
    </DxDataGrid>
    <div  style="display: flex; justify-content: flex-end; gap: 8px;">
      <DxButton text="Salvează drepturile de la acest rol" type="success" width="300" @click="onConfirmCopy" />
      <DxButton text="Închide" type="danger" width="120" @click="onCancelCopy" />
    </div>
     
  </DxPopupSelect>


</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import { DxPopup as DxPopupAdd, DxToolbarItem } from 'devextreme-vue/popup';
import { DxItem, DxForm, DxLabel } from 'devextreme-vue/form';
import { DxPopup as DxPopupSelect } from 'devextreme-vue/popup';
import {
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxToolbar,
  DxEditing,
  DxPopup,
  DxItem as DxItemForm,
  DxForm as DxFormGrid,
  DxValidationRule,
  DxRequiredRule,
} from 'devextreme-vue/data-grid';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';
import notify from 'devextreme/ui/notify';
import { locale, loadMessages } from 'devextreme/localization';
import AUTH_Roluri from '@/services/AUTH/AUTH_Roluri';
import ResponseData from '@/types/responseData';
import Roluri from '@/types/auth/roluri';
import AUTH_DrepturiRoluri from '@/services/AUTH/AUTH_DrepturiRoluri';

export default defineComponent({
  components: {
    DxToolbar,
    DxDataGrid,
    DxColumn,
    DxSorting,
    DxSelection,
    DxFilterRow,
    DxStateStoring,
    DxLoadPanel,
    DxPaging,
    DxButton,
    DxItem,
    DxPopup,
    DxForm,
    DxLabel,
    DxEditing,
    DxPopupAdd,
    DxToolbarItem,
    DxItemForm,
    DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
    DxPopupSelect
  },
  data() {
    return {

      dsRoluri: [] as Roluri[],
      isModalVisible: false,
      formData: {
        Cod: '',
        Nume: '',
        Explicatie: '',
      },
      isCopyPopupVisible: false,
      rolesDataSource: [] as Roluri[],
      selectedRole: null as Roluri | null,
      copiedEntityIds: [] as (number | string)[],
      deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
      dataGridRef: ref<DxDataGrid | null>(null),
      successButtonOptions: {
        type: 'success',
        stylingMode: 'contained',
        text: 'Salvează',
        onClick: () => {
          this.onSaveEdit();
        },
      },
      dangerButtonOptions: {
        type: 'danger',
        stylingMode: 'contained',
        text: 'Închide',
        onClick: () => {
          this.onCancelEdit();
        },
      },
      customTitleTemplate() {
        return `
        <div style="background-color: #ff2c21; font-size: 16px; float: right; height:47px; width:600px; color: white; 
        font-weight: bold;  padding: 12px; padding-right: 450px;  position: relative;  left: 30px;">
          Editare
        </div>
      `;
      },
    };
  },
  methods: {
    getRoluri() {
      AUTH_Roluri.get()
        .then((response: ResponseData) => {
          this.dsRoluri = response.data;
          this.rolesDataSource = response.data;
        })
        .catch((e: Error) => {
          console.log(e)
        });
    },
    onCopyRights() {
      this.isCopyPopupVisible = true;
      if (!this.rolesDataSource?.length)
        this.getRoluri();
    },

    onRoleGridSelectionChanged(e: any) {
      this.selectedRole = e?.selectedRowsData?.[0] ?? null;
    },

    async onConfirmCopy() {
      if (!this.selectedRole) {
        notify('Selectează un rol sursă.', 'warning', 2000);
        return;
      }
      this.isCopyPopupVisible = false;
      notify(`Rol sursă selectat: „${this.selectedRole.Nume}”.`, 'success', 1800);
    },

    async onSaveAdd() {
      try {
        const created: ResponseData = await AUTH_Roluri.save({
          Nume: this.formData.Nume,
          Cod: this.formData.Cod,
          Explicatie: this.formData.Explicatie,
        });
        const newRoleId = String(created?.data?.ID);
        if (!newRoleId) throw new Error('Nu am primit ID-ul noului rol.');

        if (this.selectedRole?.ID) {
          await AUTH_DrepturiRoluri.copyRights({
            sourceRoleId: String(this.selectedRole.ID),
            targetRoleId: newRoleId,
          });
        }

        notify('Rol creat și drepturi copiate.', 'success', 2200);

        this.isModalVisible = false;
        this.selectedRole = null;
        this.formData = {};
        this.getRoluri();
      } catch (err) {
        console.error(err);
        notify('Salvarea rolului sau copierea drepturilor a eșuat.', 'error', 2800);
      }
    },
    onCancel() {
      this.isModalVisible = false;
      this.copiedEntityIds = [];
      this.selectedRole = null;
    },

    onCancelCopy() {
      this.isCopyPopupVisible = false;
    },
    onSelectionChanged(e) {
      const selectedRowData = e.selectedRowsData[0];

      if (selectedRowData) {
        this.$emit('selection-changed', selectedRowData);

      }
    },
    onAddClick() {
      this.isModalVisible = true;
    },
    async onRowUpdating(e: any) {
      try {
        const payload = { ...e.oldData, ...e.newData };
        await AUTH_Roluri.update(payload);
        notify("Rol actualizat cu succes!", "success", 2000);
        await this.getRoluri();
      } catch (err: any) {
        console.error(err);
        notify(err?.response?.data?.message ?? "Numele exista deja!", "error", 2000);
        e.cancel = true;
      }
    },
    setDeleteConfirmationMessage() {
      const dataGrid = this.$refs.dataGridRef?.instance;
      dataGrid.option('editing', {
        allowUpdating: true,
        allowDeleting: true,
        mode: 'popup',
        texts: {
          confirmDeleteMessage: this.deleteConfirmationMessage,
          confirmDeleteTitle: "Confirmare Ștergere",
        }
      });
    },

    loadRolesForCopy() {
      try {

      } catch (err) {
        console.error(err);
        notify('Nu s-au putut încărca rolurile.', 'error', 3000);
      }
    },
    onClick() {
      this.isModalVisible = true;
    },
    onColumnChooserClick() {
      const dataGrid = this.$refs.dataGrid.instance;
      dataGrid.showColumnChooser();
    },
    onRefreshClick() {
      this.getRoluri();
      notify('Datele au fost actualizate cu succes!', 'success', 1000)
    },
    onCancelEdit() {
      this.dataGridRef?.instance?.cancelEditData();
    },
    onSaveEdit() {
      this.dataGridRef?.instance?.saveEditData();
    },
    onRowRemoving(e: any) {
      try {
        AUTH_Roluri.delete(e.data.ID)
        notify('Datele au fost șterse cu succes!', 'success', 1000);
        this.getRoluri();
      } catch (err) {
        console.error(err)
        notify('Ștergerea a eșuat!', 'error', 1000);
        e.cancel = true;
      }
    },
    onRowInserting() {
      notify('Datele au fost adăugate cu succes!', 'success', 1000)
    },
  },
  mounted() {
    this.getRoluri();
    this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
    this.setDeleteConfirmationMessage();
    loadMessages({
      "ro": {
        "Yes": "Da",
        "No": "Nu",
      }
    });
    locale('ro');
  },
});
</script>
<style scoped>

.editPopup .dx-popup-title {
  background-color: #ff2c21 !important;
  font-size: 15px !important;
  color: white !important;
  font-weight: bold !important;
  padding: 10px !important;
  padding-left: 20px !important;
}
</style>
